import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.announcements || initialState;

export const selectAnnouncements = createSelector(
  [selectDomain],
  announcements => announcements,
);
